// extracted by mini-css-extract-plugin
export default {"container":"PostsPage_container__VKKss","search-container":"PostsPage_search-container__AQUb2"};